<template>
  <div>
    <v-row>
      <v-col>
        <v-select
          v-model="id_part_program"
          label="Part Program"
          :items="part_program_list"
          item-text="name"
          item-value="id"
          @change="selectProgram"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-data-table
      :items="variabili.filter((e) => e.validita == 1)"
      :headers="headers"
    >
      <template v-slot:[`item.valore`]="{ item }">
        <v-text-field dense v-model="item.valore"> </v-text-field>
      </template>
    </v-data-table>
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
  name: "GestioneFasiValori",
  components: {
    SnackbarQV,
  },
  props: {
    id_macchina: {
      type: Number,
    },
    id_fase: {
      type: Number,
    },
    access: {
      type: Number,
    },
    id_commessa_dettaglio: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      id_part_program: null,
      part_program_list: [],
      variabili: [],
      headers: [
        {
          text: "Variabile",
          value: "nome",
        },
        {
          text: "Valore",
          value: "valore",
        },
      ],
    };
  },
  mounted() {
    this.getPartProgram();
  },
  methods: {
    getPpJSON(){
        /*var woValues = "";
        if(this.variabili.length > 0){
            woValues = JSON.stringify(this.variabili);
        }*/

        console.log(this.id_commessa_dettaglio);
        let request = {
        controller: "magazzino",
        method: "POST",
        richiesta: {
          action: "getpartprogramjson",
          token: localStorage.getItem("user_token"),
          id_macchina: this.id_macchina,
          id_partprogram: this.id_part_program,
          id_commessa_dettaglio: this.id_commessa_dettaglio,
          workorder_values: this.variabili,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        var tempProg = res.data.result;

        let request2 = {
        controller: "quickConnext",
        method: "PUT",
        richiesta: {
          action: "sendpartprogram",
          token: localStorage.getItem("user_token"),
          call_type: 0,
          id_macchina: tempProg.id_macchina,
          part_program: tempProg.part_program,
        },
      };

      this.$store
        .dispatch("connext", request2)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Part Program Inviato");
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print("error", "Part Program non Inviato: " + err);
        });

        
      }).catch((err) => {
        console.log(err);
        this.$refs.SnackbarQV.print("error", "Part Program non Inviato");
      });
    },
    saveProgram() {
      let request = {
        controller: "magazzino",
        method: "PUT",
        richiesta: {
          action: "setfasipartprogramvalori",
          token: localStorage.getItem("user_token"),
          fasi_partprogram_valori: this.variabili,
        },
      };

      this.$store
        .dispatch("api", request)
        .then(() => {
          this.$refs.SnackbarQV.print("success", "Valori Salvati");
        })
        .catch((err) => {
          console.log(err);
          this.$refs.SnackbarQV.print("error", "Valori non Salvati");
        });
    },
    selectProgram() {
      let request = {
        controller: "magazzino",
        method: "POST",
        richiesta: {
          action: "getfasipartprogramvalori",
          token: localStorage.getItem("user_token"),
          id_macchina: this.id_macchina,
          id_partprogram: this.id_part_program,
          idciclo_fasi_macchina: this.id_fase,
          access: this.access,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.variabili = res.data.result.fasi_partprogram_valori;
      });
    },
    getPartProgram() {
      let request = {
        controller: "quickConnext",
        method: "POST",
        richiesta: {
          action: "getmachineprogramparameters",
          token: localStorage.getItem("user_token"),
          id_macchina: this.id_macchina,
        },
      };

      this.$store.dispatch("connext", request).then((res) => {
        this.part_program_list = res.data;
      });
    },
  },
};
</script>